import Box from "@mui/material/Box";
import { EmtTypography } from "./EmtTypography";
import Image from "next/image";

interface Props {
  icon: string;
  children: React.ReactNode;
}

export function EmtInfoBox(props: Props) {
  const { children, icon, ...rest } = props;
  return (
    <Box
      {...rest}
      sx={{
        display: "flex",
        flexBasis: "100%",
        gap: "10px",
        height: 0,
        backgroundColor: "#FEEAEA",
        borderRadius: "16px",
        padding: "16px",
        "& strong": { color: "#C32021" },
      }}
    >
      <Image src={icon} alt="icon" width={15} height={15} />
      <EmtTypography variant="body2" color="textPrimary">
        {children}
      </EmtTypography>
    </Box>
  );
}
